import { z } from 'zod';
import { DOCUMENT_TYPES, RECEIPT_CATEGORIES } from '../types';

/**
 * Schéma de validation du formulaire de revue des données extraites.
 * Utilisé via zodResolver (React Hook Form) ; les messages sont affichés
 * dans le formulaire.
 */
export const receiptFormSchema = z.object({
  merchant: z
    .string({ error: 'Le commerçant est requis' })
    .trim()
    .min(1, 'Le commerçant est requis')
    .max(120, '120 caractères maximum'),
  date: z
    .string({ error: 'La date est requise' })
    .regex(/^\d{4}-\d{2}-\d{2}$/, 'Date invalide (format attendu : AAAA-MM-JJ)')
    .refine((value) => {
      const [year, month, day] = value.split('-').map(Number);
      const date = new Date(year, month - 1, day);

      return (
        date.getFullYear() === year &&
        date.getMonth() === month - 1 &&
        date.getDate() === day &&
        year >= 1900 &&
        date <= new Date()
      );
    }, 'Date invalide'),
  total: z.coerce
    .number({ error: 'Le montant doit être un nombre' })
    .positive('Le montant doit être supérieur à 0'),
  vat: z.coerce
    .number({ error: 'La TVA doit être un nombre' })
    .min(0, 'La TVA ne peut être négative'),
  currency: z
    .string({ error: 'La devise est requise' })
    .trim()
    .regex(/^[A-Za-z]{3}$/, 'Code devise invalide (ex. EUR)'),
  category: z.enum(RECEIPT_CATEGORIES, { error: 'La catégorie est requise' }),
  documentType: z.enum(DOCUMENT_TYPES, { error: 'Le type de document est requis' }),
  confidence: z.number().min(0).max(1),
});

export type ReceiptFormValues = z.output<typeof receiptFormSchema>;
export type ReceiptFormInput = z.input<typeof receiptFormSchema>;
